import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

export default function OrderPaymentButtonsComponent({
  context,
  orderStatus,
  paymentStatus,
  handleDeclineConfirmation,
  handleCancel,
  onSubmitPayment,
  onSubmitGuestBill,
  onSubmitSplitBill
}) {
  const navigate = useNavigate();
  const [isPaymentPage, setIsPaymentPage] = useState(false);
  const [isSplitBill, setIsSplitBill] = useState(false);

  useEffect(() => {
    const pathName = window.location.pathname;
    if (pathName.match(/^\/order\/([0-9a-fA-F]{24})\/payment$/)) {
      setIsPaymentPage(true);
    } else {
      setIsPaymentPage(false);
    }

    if (pathName.match(/^\/order\/([0-9a-fA-F]{24})\/split-bill$/)) {
      setIsSplitBill(true);
    } else {
      setIsSplitBill(false);
    }
  }, []);
  
  return (
    <div className="text-right">
      {!isSplitBill && (
        <>
          <button
            key="decline"
            onClick={handleDeclineConfirmation}
            style={{
              backgroundColor: "#FF4D4F",
              color: "#FFFFFF",
              fontFamily: "ubold",
              border: "none",
              padding: "8px 16px",
              borderRadius: "4px",
              cursor: "pointer",
              marginRight: "10px",
              display: `${orderStatus === "pending" ? "" : "none"}`,
            }}
          >
            Decline
          </button>
          {paymentStatus === 0 && orderStatus.toLowerCase() === 'ongoing' && (
            <button
              key="guestBill"
              onClick={onSubmitGuestBill}
              style={{
                backgroundColor: "#D9D9D9",
                color: "#000000",
                fontFamily: "ubold",
                border: "none",
                padding: "8px 16px",
                borderRadius: "4px",
                cursor: "pointer",
                marginRight: "10px",
              }}
            >
              Guest Bill
            </button>
          )}
          <button
            key="cancel"
            onClick={handleCancel}
            style={{
              backgroundColor: "#FFD700",
              color: "#000000",
              fontFamily: "ubold",
              border: "none",
              padding: "8px 16px",
              borderRadius: "4px",
              cursor: "pointer",
              marginRight: "10px",
            }}
          >
            {isPaymentPage ? "Back" : "Close"}
          </button>

          <button
            key="ok"
            onClick={onSubmitPayment}
            style={{
              backgroundColor: "#2EC114",
              color: "#FFFFFF",
              fontFamily: "ubold",
              border: "none",
              padding: "8px 16px",
              borderRadius: "4px",
              cursor: "pointer",
            }}
          >
            {orderStatus !== "pending" ? "Receive" : "Accept"}
          </button>
        </>
      )}

      {isSplitBill && (
        <>
          <button
            key="navBack"
            onClick={() => navigate(-1)}
            style={{
              backgroundColor: "#FF4D4F",
              color: "#FFFFFF",
              fontFamily: "ubold",
              border: "none",
              padding: "8px 16px",
              borderRadius: "4px",
              cursor: "pointer",
              marginRight: "10px",
            }}
          >
            Cancel
          </button>

          <button
            key="ok"
            onClick={onSubmitSplitBill}
            style={{
              backgroundColor: "#2EC114",
              color: "#FFFFFF",
              fontFamily: "ubold",
              border: "none",
              padding: "8px 16px",
              borderRadius: "4px",
              cursor: "pointer",
            }}
          >
            Confirm
          </button>
        </>
      )}
    </div>
  );
}
